import angular from 'angular'

import announceModule from './announce/announce.module'
import moveModule from './move/move.module'
import parkModule from './park/park.module'
import scrapModule from './scrap/scrap.module'
import unparkModule from './unpark/unpark.module'

import maneuverMenu from './maneuver.menu'
import maneuverRoutes from './maneuver.routes'
import maneuverRun from './maneuver.run'

const name = 'routingManeuver'

angular.module(name, [
  moveModule,
  parkModule,
  scrapModule,
  unparkModule,
  announceModule,
])
  .run(maneuverRun)
  .config(maneuverRoutes)
  .factory('maneuverMenu', maneuverMenu)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/maneuver.module.js